import { tkParse } from '@moke/vue-tk'
export default {
  className: 'blacklist',
  fields: [
    {
      name: 'user',
      note: '手机号',
      searchKey: ['phone'],
      listWhere: (where) => {
        where.phone = {
          $exists: true
        }
      }
    }
  ],
  search: [
    'user'
  ],
  action: {
    export: false,
    create: false,
    edit: false,
    delete: false,
    cancel: {
      type: 'row',
      text: '移除黑名单',
      callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
        await vm.confirm('警告', '您确定要将该用户从黑名单中移除吗?')
        try {
          await tkParse.put(`/classes/_User/${record.user.objectId}`, { isBlack: false })
          await tkParse.delete(`/classes/blacklist/${record.objectId}`)
          vm.$notification['success']({
            message: '操作成功',
            description: '用户已移除'
          })
          vm.refresh()
        } catch (e) {
          console.log(e)
          vm.$notification['error']({
            message: '网络错误',
            description: '移除失败'
          })
        }
      }
    }
  }
}
